interface Props {
  /** Tiny uppercase eyebrow above the title — sets context (e.g. sign name, date). */
  eyebrow?: string
  title: string
  /** Optional element rendered to the right of the title (e.g. action button). */
  action?: React.ReactNode
}

/**
 * Unified section header used on every detail screen so titles and their
 * eyebrows have the same visual rhythm everywhere. Pairs nicely with cards
 * on rounded-3xl bg-white/70 ring-1 ring-sage-200/60.
 */
export function SectionHeader({ eyebrow, title, action }: Props) {
  return (
    <header className="mb-3 flex items-end justify-between gap-3">
      <div className="flex flex-col gap-0.5">
        {eyebrow && (
          <span className="text-[10px] font-medium uppercase tracking-[0.18em] text-sage-500">
            {eyebrow}
          </span>
        )}
        <h2 className="font-serif text-xl text-sage-800">{title}</h2>
      </div>
      {action}
    </header>
  )
}
